export const ICONS_PATH = '/local/js/specialty/assets/images/';
export const DEFAULT_GRINDING_ICON_PATH = `${ICONS_PATH}icon-grinding-default.svg`;
export const REGION_COOKIE_NAME = 'current_city';
export const REGION_CONFIRMED_COOKIE_NAME = 'confirmed_city';

export const SUGGEST_START_LIMIT = 3;
export const SUGGEST_TIMEOUT = 500;

export const VAT_ITEMS = [
    {
        label: 'Общая (с НДС)',
        value: window?.specialtyApp?.settings?.COMPANY_VAT_SYSTEM_COMMON || 'common',
    },
    {
        label: 'Упрощённая (без НДС)',
        value: window?.specialtyApp?.settings?.COMPANY_VAT_SYSTEM_SIMPLE || 'simple',
    },
];

export const LABS_SETTINGS = {
    openLabsAfterLoginLSKey: 'openLabsAfterLogin',
    lkLabsURL: '/personal/labs/',
};

export const EVENT_RESET_FILTER = 'resetFilter';
export const EVENT_APPLY_FILTER_STRING = 'applyFilterString';
export const FIND_LAB_BY_BREW = 'findLabByBrew';
